import * as React from 'react';
import { Button } from '@cian/button-component';
import { IUserSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { SubscriptionPopup } from './subscription_popup';
import { trackOpenClick } from './tracking';
import * as styles from './subscription_address.css';
import { ICreateSubscriptionRequest } from '../../repositories/monolithPython/v1/create-subscription';

export interface ISubscriptionAddressStoreProps {
  isOpen: boolean;
  isLoad: boolean;
  isSubscribe: boolean;
  globalError?: string;
  offer: IOfferSchema;
  user: IUserSchema | null;
  pushSubscribed: boolean;
}

export interface ISubscriptionAddressDispatchProps {
  setVisible(isOpen: boolean): void;
  fetchCreateSubscription(parameters: ICreateSubscriptionRequest): Promise<void>;
}

export type TSubscriptionAddressProps = ISubscriptionAddressStoreProps & ISubscriptionAddressDispatchProps;

export class SubscriptionAddress extends React.Component<TSubscriptionAddressProps, {}> {
  public render() {
    const {
      setVisible,
      isOpen,
      isLoad,
      user,
      pushSubscribed,
      offer,
      fetchCreateSubscription,
      isSubscribe,
      globalError,
    } = this.props;

    const geoHouse = offer.geo && offer.geo.address &&
      offer.geo.address.find(item => item.type === 'house');

    if (!geoHouse) {
      return null;
    }

    return (
      <div className={styles['subscribe-address']}>
        <p>Следить за объявлениями в этом доме</p>
        <Button
          type="button"
          onClick={() => {
            trackOpenClick();
            setVisible(true);
          }}
        >
          Подписаться
        </Button>

        <SubscriptionPopup
          fetchCreateSubscription={fetchCreateSubscription}
          offer={offer}
          isOpen={isOpen}
          isLoad={isLoad}
          isSubscribe={isSubscribe}
          globalError={globalError}
          onClose={() => setVisible(false)}
          isAuthenticated={Boolean(user && user.isAuthenticated)}
          user={user}
          pushSubscribed={pushSubscribed}
        />
      </div>
    );
  }
}
